import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { BrandActionTypes, GetBrand, saveBrand } from './index';

// Api's
import { brandApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getBrandSaga(action: GetBrand) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      brandApi.getDomain,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveBrand(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveBrand(null, true, resultError.messagesDataError));
    }
  }
}

